/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShadowSubsystemActionOneOf1
 */
export interface ShadowSubsystemActionOneOf1 {
    /**
     * 
     */
    tool: ShadowSubsystemActionOneOf1ToolEnum;
    /**
     * 
     */
    recipient: string;
    /**
     * 
     */
    message: string;
}


/**
 * @export
 */
export const ShadowSubsystemActionOneOf1ToolEnum = {
    DraftMessage: 'draft_message',
} as const;
export type ShadowSubsystemActionOneOf1ToolEnum = typeof ShadowSubsystemActionOneOf1ToolEnum[keyof typeof ShadowSubsystemActionOneOf1ToolEnum];


/**
 * Check if a given object implements the ShadowSubsystemActionOneOf1 interface.
 */
export function instanceOfShadowSubsystemActionOneOf1(value: object): value is ShadowSubsystemActionOneOf1 {
    if (!('tool' in value) || value['tool'] === undefined) return false;
    if (value['tool'] !== 'draft_message') return false;
    
    if (!('recipient' in value) || value['recipient'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function ShadowSubsystemActionOneOf1FromJSON(json: any): ShadowSubsystemActionOneOf1 {
    return ShadowSubsystemActionOneOf1FromJSONTyped(json, false);
}

export function ShadowSubsystemActionOneOf1FromJSONTyped(json: any, ignoreDiscriminator: boolean): ShadowSubsystemActionOneOf1 {
    if (json == null) {
        return json;
    }
    return {
        
        'tool': json['tool'],
        'recipient': json['recipient'],
        'message': json['message'],
    };
}

export function ShadowSubsystemActionOneOf1ToJSON(json: any): ShadowSubsystemActionOneOf1 {
    return ShadowSubsystemActionOneOf1ToJSONTyped(json, false);
}

export function ShadowSubsystemActionOneOf1ToJSONTyped(value?: ShadowSubsystemActionOneOf1 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tool': value['tool'],
        'recipient': value['recipient'],
        'message': value['message'],
    };
}

